import { Navigate } from 'react-router-dom';

const ProtectedVendorRoute = ({ children }) => {
  const isVendor = sessionStorage.getItem('vendorPhone');
  return isVendor ? children : <Navigate to="/code-login" replace />;
};

export default ProtectedVendorRoute;
